
export function store_data(data: any, key: any)
{
    if (!window.localStorage || !window.JSON || !key)
    {
        return;
    }
    localStorage.setItem(key, JSON.stringify(data));
}
